import { render, staticRenderFns } from "./RolesManager.vue?vue&type=template&id=13e3a00d&scoped=true&"
import script from "./RolesManager.vue?vue&type=script&lang=js&"
export * from "./RolesManager.vue?vue&type=script&lang=js&"
import style0 from "./RolesManager.vue?vue&type=style&index=0&id=13e3a00d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13e3a00d",
  null
  
)

export default component.exports